import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Ellipsis = (props) => {
	const {content, lines, width} = props;

	return lines === 1 ? (
		<StyledSingleLineEllipsis className={'ellipsis-single-line'} title={content} customWidth={width}>
			{content}
		</StyledSingleLineEllipsis>
	) : (
		<StyledMultiLineEllipsis className={'ellipsis-multi-line'} title={content} customWidth={width} lines={lines}>
			{content}
		</StyledMultiLineEllipsis>
	);
};

export default Ellipsis;

Ellipsis.defaultProps = {
	lines: 1,
	width: ''
};

Ellipsis.propTypes = {
	content: PropTypes.string.isRequired,
	lines: PropTypes.oneOf([1, 2, 3]),
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const StyledEllipsis = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	width: ${(props) => (props.customWidth ? `${props.customWidth}rem` : 'auto')};
`;

const StyledSingleLineEllipsis = styled(StyledEllipsis)`
	white-space: nowrap;
`;

const StyledMultiLineEllipsis = styled(StyledEllipsis)`
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: ${(props) => props.lines};
	word-wrap: break-word;
	white-space: break-spaces;
`;
